import { CustomerSession } from '../models/customer-session/CustomerSession';
import store from '../store/store';
import { apiClient } from './ApiClient';
import { getDb, getLast, updateOne } from './IndexedDbService';

const sessionDuration = 30 * 60 * 1000;

export async function getCurrentSession(
    autoUpdateLastInteractionAt = false
): Promise<CustomerSession> {
    const last = await getLast('sessions');
    let current: CustomerSession;
    if (!last || !isSessionActive(last.value)) {
        current = await apiClient['customer-session'].createCustomerSession({
            body: {
                url: document.location.href,
                referrer: document.referrer
            }
        });
        await getDb().add('sessions', {
            ...current,
            createdAt: new Date(current.createdAt)
        });
    } else {
        current = last.value;
    }
    if (autoUpdateLastInteractionAt) {
        return renewSession(current, new Date());
    } else {
        return current;
    }
}

function isSessionActive(
    session: CustomerSession,
    atTime = new Date()
): boolean {
    return (
        atTime.getTime() - sessionDuration <
        (session.lastInteractionAt ?? session.createdAt).getTime()
    );
}

function renewSession(
    session: CustomerSession,
    lastInteractionAt = new Date()
): Promise<CustomerSession> {
    const expire = new Date(lastInteractionAt.getTime() + sessionDuration);
    store.dispatch.productComparisonState.setExpiredAt(expire.toISOString());
    store.dispatch.productsGridState.setExpiredAt(expire.toISOString());
    store.dispatch.featureState.setExpiredAt(expire.toISOString());
    return updateOne(
        'sessions',
        session.id,
        session => ({
            ...session,
            lastInteractionAt
        }),
        { useInLineKeysToUpdate: true }
    );
}
